import React from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import is from 'is_js';
import { List } from 'immutable';
import ReactGA from 'react-ga4';
import PropTypes from 'prop-types';
import styles from './style.postcss';

import { Grid, connect, ApiCall } from 'omni-common-ui';

import Student from './Student';
import {
  PaperbasedHomeworkStatus as Status,
  covertBackendPaperBasedHomeworkStatusToHomeworkStatus,
} from 'data/PaperBasedHomework/status';
import UnsavedChangesTrackingPageComponent from 'components/UnsavedChangesTrackingPageComponent';
import NoContentMessage from 'components/NoContentMessage';
import { actions as PaperbaseHomworkAction } from 'data/PaperBasedHomework';
import { actions as GroupMembers } from 'data/GroupMembers';
import HomeworkContentPopup from '../../HomeworkContentPopup';
import UnsavedChangesWarning from 'components/UnsavedChangesWarning';
import {
  isMarkable,
  getHomeworkStudentList,
} from 'data/PaperBasedHomework/accessors';
import { actions as uiState } from 'data/UiState';

const MARKING = 'edit';

export class MarkHomeworkDayView extends UnsavedChangesTrackingPageComponent {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      students: props.students,
      homeworkContentPopupOpenForSessionId: null,
      isChangeMade: false,
    });
  }

  componentWillMount() {
    this._fetchDataIfNeeded(this.props);
    super.componentWillMount();
  }

  componentWillReceiveProps(nextProps) {
    let { students } = nextProps;
    if (nextProps.location.pathname.endsWith('/edit')) {
      let studentsWithLastChange = this.state.students || students;
      studentsWithLastChange =
        studentsWithLastChange &&
        this._getStudentsViewModel(studentsWithLastChange);
      students = studentsWithLastChange;
    }
    this.setState({ students });
    this._fetchDataIfNeeded(nextProps);
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState({ isChangeMade: false });
    }
  }

  _getStudentsViewModel(studentsWithLastChange) {
    let models = studentsWithLastChange;
    models = models.map((lessonHomework) =>
      lessonHomework.update(
        'studentPaperBasedHomeworks',
        (studentPaperBasedHomeworks) =>
          studentPaperBasedHomeworks.map((studentPaperBasedHomework) =>
            studentPaperBasedHomework.set(
              'homeworkStatus',
              covertBackendPaperBasedHomeworkStatusToHomeworkStatus(
                studentPaperBasedHomework.homeworkStatus,
                true,
              ),
            ),
          ),
      ),
    );
    models = models.map((lessonHomework) =>
      lessonHomework.update(
        'studentTutorialHomeworks',
        (studentTutorialHomeworks) =>
          studentTutorialHomeworks.map((studentTutorialHomework) =>
            studentTutorialHomework.set(
              'homeworkStatus',
              covertBackendPaperBasedHomeworkStatusToHomeworkStatus(
                studentTutorialHomework.homeworkStatus,
                true,
              ),
            ),
          ),
      ),
    );
    return models;
  }

  _fetchDataIfNeeded(props) {
    const { sessionPlanId } = props.params;
    props.fetchPaperBasedHomeworkIfNeeded(sessionPlanId);
  }

  _handleMark(studentId, level, unitId, lessonNumber, status) {
    let { students } = this.state;
    let updatedEntity;

    if (level === 'first') updatedEntity = 'studentPaperBasedHomeworks';
    else if (level === 'second') updatedEntity = 'studentTutorialHomeworks';

    const studentsMapperUpdate = (entityType, update) =>
      students.map((lessonHomework) => {
        if (
          `${lessonHomework.unitId}` === `${unitId}` &&
          `${lessonHomework.lessonNumber}` === `${lessonNumber}`
        ) {
          return lessonHomework.update(entityType, (studentHomeworks) =>
            studentHomeworks.map((studentHomework) => update(studentHomework)),
          );
        }
        return lessonHomework;
      });

    students = studentsMapperUpdate(updatedEntity, (studentHomework) => {
      if (studentHomework.studentId === `${studentId}`) {
        this._gaChangeHomeworkStatus(
          studentId,
          studentHomework.homeworkStatus,
          status,
        );
        return studentHomework.set('homeworkStatus', status);
      }
      return studentHomework;
    });

    this.setState({ students, isChangeMade: true });
  }

  _handleSaveHomeworkStatus() {
    const { params, groupId, submitMarkPaperBasedHomework, fetchGroupMembers } =
      this.props;
    const { sessionPlanId } = params;
    const { students } = this.state;
    submitMarkPaperBasedHomework(sessionPlanId, students).then(() => {
      fetchGroupMembers(groupId);
    });
    this._forcePushRoute(this.props.buildRoute('..'));
  }

  _gaChangeHomeworkStatus(student, perviousStatus, nextStatus) {
    ReactGA.event({
      category: 'PaperBasedHomeworkStatus',
      action: 'Changed status',
      label: `Changed status for ${student} from ${perviousStatus} to ${nextStatus}`,
    });
  }

  _renderContentPopup() {
    const { homeworkContentPopupOpenForSessionId } = this.state;

    if (is.not.null(homeworkContentPopupOpenForSessionId)) {
      return (
        <HomeworkContentPopup
          title="Paper-based Practice"
          url={`/sessions/${homeworkContentPopupOpenForSessionId}/assigned-paper-based-homework`}
          onOkButtonClicked={() => this._onContentPopupOkClicked()}
        />
      );
    }
    return null;
  }

  _onContentPopupOkClicked() {
    this.setState({ homeworkContentPopupOpenForSessionId: null });
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      location: window.location.href,
      title: document.title,
    });
  }

  _isChangesPresent() {
    return this.props.marking && this.state.isChangeMade;
  }

  routerWillLeave(nextLocation) {
    if (nextLocation && nextLocation.pathname.endsWith('/save')) {
      this._handleSaveHomeworkStatus();
    } else if (nextLocation && nextLocation.pathname.endsWith('/discard')) {
      this._forcePushRoute(this.props.buildRoute({ mode: '' }), {
        students: this.props.students,
      });
    } else if (nextLocation && nextLocation.pathname.endsWith('/popup')) {
      this._forcePushRoute(this.props.buildRoute({ mode: '' }), {
        homeworkContentPopupOpenForSessionId: this.props.params.sessionPlanId,
      });
    } else {
      return super.routerWillLeave(nextLocation);
    }
  }

  _sortStudentMapByLesson(a, b) {
    if (a.unitOrderingSequence !== b.unitOrderingSequence) {
      return a.unitOrderingSequence - b.unitOrderingSequence;
    }
    return a.lessonNumber - b.lessonNumber;
  }

  _sortStudentInLessson(lessonHomework) {
    const students = lessonHomework.studentPaperBasedHomeworks;
    if (!students) {
      return;
    }
    const sortedStudents = students.sortBy((student) =>
      student.studentGeneralInfo.firstName.toLowerCase(),
    );
    const inProductionStudents = [];
    const notInProductionStudents = [];
    sortedStudents.map((student) => {
      if (student.isInProduction) {
        inProductionStudents.push(student);
      } else {
        notInProductionStudents.push(student);
      }
      return false;
    });
    return new List(inProductionStudents.concat(notInProductionStudents));
  }

  _renderLessonNumber() {
    const { students } = this.state;
    if (
      !students ||
      students.size === 0 ||
      students.some((student) =>
        student.studentPaperBasedHomeworks.some((homework) =>
          is.undefined(homework.studentGeneralInfo),
        ),
      )
    ) {
      return (
        <NoContentMessage text="No paper-based practice on this session." />
      );
    }
    return students.sort(this._sortStudentMapByLesson).map((lessonHomework) => {
      const header = `Unit ${lessonHomework.unitOrderingSequence}, Lesson ${lessonHomework.lessonNumber}`;
      const studentHomeworks = this._sortStudentInLessson(lessonHomework);
      return (
        <div>
          <h2 key={header}>{header}</h2>
          {studentHomeworks && studentHomeworks.size > 0 ? (
            <div className={styles.MarkHomeworkDayView_lessonHomework}>
              {this._renderStudent(
                studentHomeworks,
                lessonHomework.studentTutorialHomeworks,
                lessonHomework.unitId,
                lessonHomework.lessonNumber,
              )}
            </div>
          ) : (
            <NoContentMessage text="No paper-based practice on this lesson." />
          )}
        </div>
      );
    });
  }

  _renderStudent(
    studentHomeworks,
    studentTutorialHomeworks,
    unitId,
    lessonNumber,
  ) {
    return studentHomeworks.map((studentHomeworkData) => {
      const tutorialHomework = studentTutorialHomeworks.find(
        (th) => studentHomeworkData.studentId === th.studentId,
      );
      return (
        <Grid.Item
          key={`${unitId}-${lessonNumber}-${studentHomeworkData.studentId}`}
          xs={12}
          sm={6}
          md={4}
          lg={3}
        >
          <Student
            name={studentHomeworkData.studentGeneralInfo.firstName}
            surname={studentHomeworkData.studentGeneralInfo.lastName}
            avatarUrl={studentHomeworkData.studentGeneralInfo.avatarUrl}
            firstStatus={studentHomeworkData.homeworkStatus || Status.unmarked}
            secondStatus={
              tutorialHomework ? tutorialHomework.homeworkStatus : undefined
            }
            productionStatus={studentHomeworkData.studentStatus}
            isInProduction={studentHomeworkData.isInProduction}
            gender={studentHomeworkData.studentGeneralInfo.gender}
            localname={studentHomeworkData.studentGeneralInfo.localName}
            markable={this.props.marking}
            onMarkComplete={(level) =>
              this._handleMark(
                studentHomeworkData.studentId,
                level,
                unitId,
                lessonNumber,
                Status.complete,
              )
            }
            onMarkIncomplete={(level) =>
              this._handleMark(
                studentHomeworkData.studentId,
                level,
                unitId,
                lessonNumber,
                Status.incomplete,
              )
            }
            onMarkPartialComplete={(level) =>
              this._handleMark(
                studentHomeworkData.studentId,
                level,
                unitId,
                lessonNumber,
                Status.partialcomplete,
              )
            }
            onMarkNA={(level) =>
              this._handleMark(
                studentHomeworkData.studentId,
                level,
                unitId,
                lessonNumber,
                Status.notapplicable,
              )
            }
          />
        </Grid.Item>
      );
    });
  }

  _setSessionCourseSwitchMode() {
    this.props.toggleViewMode('day');
  }

  render() {
    return (
      <div>
        <Grid>
          <Grid.Group>{this._renderLessonNumber()}</Grid.Group>
        </Grid>
        <UnsavedChangesWarning
          isOpen={!!this._isNavigationWithChangesRequested()}
          isSaving={this.props.isAnyApiCallSaving}
          onSaveClicked={() => {
            this._handleSaveHomeworkStatus();
          }}
          onDiscardClicked={() => {
            this._forcePushRequestedLocation();
          }}
          onCloseClicked={() => {
            this._setSessionCourseSwitchMode();
            this._clearRequestedLocation();
          }}
          onSaved={() => {
            this._forcePushRequestedLocation();
          }}
        />
        {this._renderContentPopup()}
      </div>
    );
  }
}

MarkHomeworkDayView.isInMarkingRoute = (props) =>
  props.params && props.params.mode === MARKING;

MarkHomeworkDayView.propTypes = Object.assign(
  {},
  UnsavedChangesTrackingPageComponent.propTypes,
  {
    params: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
    route: PropTypes.any.isRequired,
    location: PropTypes.object.isRequired,
    pushRoute: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    children: PropTypes.node,
    markable: PropTypes.bool,
    students: PropTypes.object,
    buildRoute: PropTypes.func.isRequired,
    state: PropTypes.object.isRequired,
    fetchPaperBasedHomeworkIfNeeded: PropTypes.func,
    submitMarkPaperBasedHomework: PropTypes.func,
    isAnyApiCallSaving: PropTypes.func.isRequired,
    sessionType: PropTypes.string,
  },
);

function mapStateToProps(state, ownProps) {
  const { groupId, sessionPlanId } = ownProps.params;
  const sessionPlan = state
    .get('rootReducer')
    .get('sessionPlans')
    .get(sessionPlanId);
  const { sessionType } = sessionPlan;
  const isInMarkingRoute = MarkHomeworkDayView.isInMarkingRoute(ownProps);
  const students = getHomeworkStudentList(state, sessionPlan, groupId);
  const markable = isMarkable(state, groupId, sessionPlanId);
  const viewMode = uiState.getViewMode(state);
  return {
    markable,
    groupId: ownProps.params.groupId,
    marking: markable && isInMarkingRoute,
    students,
    state,
    sessionType,
    viewMode,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(GroupMembers, dispatch),
    bindActionCreators(uiState, dispatch),
    bindActionCreators(PaperbaseHomworkAction, dispatch),
  );
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST'].some((method) => key.startsWith(method)),
    )
    .find((call) => ApiCall.State.isLoading(call));
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarkHomeworkDayView);



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkDayView/component.jsx